import {trans} from '@frontend/helpers'
import clsx from 'clsx'
import {Card} from 'swayok-react-mdb-ui-kit/components/Card/Card'
import {CardBody} from 'swayok-react-mdb-ui-kit/components/Card/CardBody'
import {HtmlContent} from 'swayok-react-mdb-ui-kit/components/Typography/HtmlContent'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'
import {AppConfig} from '../../../AppConfig'
import {appUrl} from '../../../AppUrl'
import {AnalyticsEventReporter} from '../../../helpers/AnalyticsEventReporter'
import {useAccountFlagsStore} from '../../../stores'

interface Props {
    className?: string
    utmSource?: string
    gridOrder?: number
    colSpan?: number
    size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
}

// Аванс за первое объявление.
export function FirstAdBonusPromoCard(props: Props) {
    const {
        className,
        utmSource = 'promo_banners_block',
        gridOrder = 0,
        colSpan,
        size,
    } = props

    const isSeller: boolean = useAccountFlagsStore(
        state => state.isSeller
    )

    if (!isSeller || !AppConfig.features.advances?.quickAdvancePage) {
        return null
    }

    const url = NavigationService.makeFullUrl(
        appUrl().quickAdvance.landing,
        null,
        {utm_source: utmSource}
    )

    return (
        <Card
            className={clsx('promo-card first-item-bonus cursor', size, className)}
            style={{
                order: gridOrder,
                gridColumn: colSpan ? `span ${colSpan}` : undefined,
            }}
            onClick={() => {
                AnalyticsEventReporter.promoBannerClick('first_ad_bonus', utmSource)
                window.open(url, '_blank')
            }}
        >
            <CardBody>
                <div className="promo-card-text-wrapper">
                    <HtmlContent
                        html={trans().common.promo.first_ad_bonus}
                        block
                    />
                </div>
            </CardBody>
        </Card>
    )
}
